import { Controller } from "stimulus"
import $ from "jquery"

function setCookie(name, value, days) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`
}

function getCookie(name) {
  const nameEQ = name + "="
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim()
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export default class extends Controller {
  static values = {
    cookieName: String,
    cookieDays: Number
  }

  connect() {
    if (!getCookie(this.cookieNameValue)) {
      setTimeout(() => {
        $(this.element).modal('show')
      }, 1000)
    }

    $(this.element).on('hidden.bs.modal', () => {
      setCookie(this.cookieNameValue, "1", this.cookieDaysValue)
    })
  }
}